export default "__VITE_PUBLIC_ASSET__cf70bd72__"